var _rect, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEventMessagesBackground({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 252,
    height: 182,
    viewBox: "0 0 252 182",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_460_8286",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 404,
    height: 182
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    y: 0.5,
    width: 404,
    height: 181,
    rx: 20,
    fill: "#E36867"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_460_8286)"
  }, /*#__PURE__*/React.createElement("rect", {
    y: 0.5,
    width: 404,
    height: 182.398,
    rx: 20,
    fill: "#6435B6"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 91.5,
    cy: 74,
    rx: 91.5,
    ry: 74,
    transform: "matrix(-1 0 0 1 200 0.5)",
    fill: "url(#paint0_linear_460_8286)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_460_8286",
    x1: 209.193,
    y1: 167.359,
    x2: 147.552,
    y2: 75.5857,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0.4
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEventMessagesBackground);
export default __webpack_public_path__ + "static/media/EventMessagesBackground.c69ed9216324a9141b7999367396d13d.svg";
export { ForwardRef as ReactComponent };